function getOfferPayback(offer) {
  if (!offer) {
    return null;
  }
  if (offer.payback) {
    return Number(offer.payback)
  }
  if (!offer.factorRate || !offer.amount) {
    return null;
  }
  const factorRate = Number(offer.factorRate)
  // calculate payback only for valid factor rate
  if (factorRate < 1 && factorRate >= 2) {
    return null;
  }
  return offer.amount * factorRate
}

function getApprovalMaxAmount(approval) {
  const option = approval.options?.at(0) ?? {}

  switch (approval?.loanProductCategoryType) {
    case 'ach':
      return option?.maxAmount
    case 'loc':
      return option?.limits?.drawAmount?.max
    case 'term':
      return option?.limits?.amount?.max
    default:
      return option?.maxAmount
  }
}

export default function sortOptions (output, requestedAmount, a, b) {
  const firstAmount = Number(a.isStaticOffer ? a.amount : getApprovalMaxAmount(a));
  const secondAmount = Number(b.isStaticOffer ? b.amount : getApprovalMaxAmount(b));

  if (firstAmount === secondAmount || (!Number.isFinite(firstAmount) && !Number.isFinite(secondAmount))) {
    const typeOrder = ['loc', 'term', 'ach'].reverse()
    const firstLoanTypePriority = typeOrder.indexOf(a?.loanProductCategoryType) + 1;
    const secondLoanTypePriority = typeOrder.indexOf(b?.loanProductCategoryType) + 1;

    if (firstLoanTypePriority !== secondLoanTypePriority) {
      return secondLoanTypePriority - firstLoanTypePriority
    }

    if (!Number.isFinite(firstAmount) && !Number.isFinite(secondAmount)) {
      return new Date(a.created) - new Date(b.created)
    }

    const firstPayback = !a.isStaticOffer && a.options.length
      ? output(a, { optionId: a.options.at(0).id })?.payback
      : getOfferPayback(a)

    const secondPayback = !b.isStaticOffer && b.options.length
      ? output(b, { optionId: b.options.at(0).id })?.payback
      : getOfferPayback(b)

    if (!firstPayback && !secondPayback) {
      return new Date(a.created) - new Date(b.created)
    }

    if (!firstPayback) {
      return 1
    } else if (!secondPayback) {
      return -1
    }

    const firstCostOfCapital = firstPayback - firstAmount
    const secondCostOfCapital = secondPayback - secondAmount

    return firstCostOfCapital - secondCostOfCapital
  }

  if (!Number.isFinite(firstAmount)) {
    return 1
  } else if (!Number.isFinite(secondAmount)) {
    return -1
  }

  // sort from max to min amount if no requested
  if (!requestedAmount) {
    return secondAmount - firstAmount
  }

  // sort from min to max to meet closest requested amount
  if (firstAmount >= requestedAmount && secondAmount >= requestedAmount) {
    return firstAmount - secondAmount
  }

  if (firstAmount >= requestedAmount) {
    return -1
  } else if (secondAmount >= requestedAmount) {
    return 1
  }

  // sort from max to min amount if loan amount less than requested
  return secondAmount - firstAmount
}
